import { KitchenTicketStatus } from '@/renderer/types/kds';

export interface KdsColumnConfig {
  status: Exclude<KitchenTicketStatus, 'SERVED'>;
  title: string;
  nextStatus: KitchenTicketStatus;
  actionLabel: string;
  headerClasses: string;
}

/** The 4 board columns, in display order. SERVED tickets leave the board
 * entirely (counted only in the Completed Orders KPI). */
export const KDS_COLUMNS: KdsColumnConfig[] = [
  {
    status: 'NEW',
    title: 'New Orders',
    nextStatus: 'IN_PREP',
    actionLabel: 'Start Preparing',
    headerClasses: 'bg-blue-50 text-blue-800 border-blue-100',
  },
  {
    status: 'IN_PREP',
    title: 'In Preparation',
    nextStatus: 'QC',
    actionLabel: 'Send to QC',
    headerClasses: 'bg-amber-50 text-amber-800 border-amber-100',
  },
  {
    status: 'QC',
    title: 'Quality Check',
    nextStatus: 'READY',
    actionLabel: 'Mark Ready',
    headerClasses: 'bg-purple-50 text-purple-800 border-purple-100',
  },
  {
    status: 'READY',
    title: 'Ready to Serve',
    nextStatus: 'SERVED',
    actionLabel: 'Mark Served',
    headerClasses: 'bg-green-50 text-green-800 border-green-100',
  },
];
